import httpClient from '@frontend/api/http';
import {
  AgentExecutionsResponse,
  ExecutionDetails,
  MemoryDetails,
} from '@frontend/types/agentExecution';
import { MemoryChunk, SpecializedAgentExecutionsResponse } from '@frontend/types/specialized-agent';

export const agentExecutionsService = {
  // Get all workflow executions
  getExecutions: async ({
    instanceId,
    agentId,
    page = 1,
    pageSize = 100,
  }: {
    instanceId: string;
    agentId?: string;
    page?: number;
    pageSize?: number;
  }): Promise<AgentExecutionsResponse> => {
    let url = `/hypatia/api/v1/${instanceId}/workflow-executions?page=${page}&page_size=${pageSize}`;
    if (agentId) {
      url = url.concat(`&workflow_agent_id=${agentId}`);
    }

    try {
      const response = await httpClient.get(url);

      // Check if response is HTML instead of JSON
      if (typeof response.data === 'string' && response.data.includes('<!doctype html>')) {
        console.error('agentExecutionsService.getExecutions - received HTML instead of JSON');
        throw new Error('API returned HTML instead of JSON - likely endpoint not found');
      }

      // @ts-expect-error: FIXME: OPAL-2388
      return response.data;
    } catch (error) {
      console.error('agentExecutionsService.getExecutions - error:', error);
      throw error;
    }
  },

  // Get executions for specific agent
  getAgentExecutions: async (
    instanceId: string,
    agentId: string,
    page = 1,
    pageSize = 100
  ): Promise<SpecializedAgentExecutionsResponse> => {
    const response = await httpClient.get(
      `/hypatia/api/v1/${instanceId}/agents/specialized/${agentId}/executions?page=${page}&page_size=${pageSize}`
    );
    // @ts-expect-error: FIXME: OPAL-2388
    return response.data;
  },

  // Get execution details using HATEOAS link
  getExecutionDetails: async (executionUrl: string): Promise<ExecutionDetails> => {
    try {
      const response = await httpClient.get(executionUrl);
      // @ts-expect-error: FIXME: OPAL-2388
      return response.data;
    } catch (error) {
      console.error('getExecutionDetails - error:', error);
      throw error;
    }
  },

  // Get memory details using HATEOAS link
  getMemoryDetails: async (memoryUrl: string): Promise<MemoryDetails> => {
    try {
      const response = await httpClient.get(memoryUrl);
      // @ts-expect-error: FIXME: OPAL-2388
      return response.data;
    } catch (error) {
      console.error('getMemoryDetails - error:', error);
      throw error;
    }
  },

  // Get memory chunks using HATEOAS link
  getMemoryChunks: async (chunksUrl: string): Promise<MemoryChunk[]> => {
    try {
      const response = await httpClient.get(chunksUrl);
      // @ts-expect-error: FIXME: OPAL-2388
      return response.data;
    } catch (error) {
      console.error('getMemoryChunks - error:', error);
      throw error;
    }
  },

  // Cancel workflow execution
  cancelWorkflowExecution: async (instanceId: string, executionId: string): Promise<void> => {
    try {
      // Use proper POST endpoint instead of PATCH
      await httpClient.post(
        `/hypatia/api/v1/${instanceId}/workflow-executions/${executionId}/cancel`
      );
    } catch (error) {
      console.error('cancelWorkflowExecution - error:', error);
      throw error;
    }
  },

  // Resume workflow execution
  resumeWorkflowExecution: async (instanceId: string, executionId: string): Promise<void> => {
    try {
      await httpClient.post(
        `/hypatia/api/v1/${instanceId}/workflow-executions/${executionId}/resume`
      );
    } catch (error) {
      console.error('resumeWorkflowExecution - error:', error);
      throw error;
    }
  },
};
